class WCCart extends WCObservable(WCDummy) {
  constructor() {
    super({ tag: WCCart.tag });
  }

  static get tag() {
    return "wc-cart";
  }

  connectedCallback() {
    this.initObserver({
      once: false,
      options: {
        rootMargin: "0px 2px 0px 0px",
        threshold: 0.1,
      },
    });
    document.addEventListener("cartChanged", this.#handleCartChange.bind(this));
    document
      .querySelectorAll(".btn-remove")
      .forEach((btn) =>
        btn.addEventListener("click", this.#handleItemRemove.bind(this))
      );
    ShopifyAjaxAPI.cart;
  }

  disconnectedCallback() {
    document.removeEventListener(
      "cartChanged",
      this.#handleCartChange.bind(this)
    );
  }

  observerCallback(entry) {
    if (entry.isIntersecting) {
      console.log("cart");
      AnalyticsLayer.trackCartView();
    }
  }

  async #handleCartChange(e) {
    this.#render(e.detail);
  }

  #handleItemRemove(e) {
    e.preventDefault();
    ShopifyAjaxAPI.change({
      id: e.target.closest("tr").getAttribute("id"),
      quantity: 0,
    });
  }

  async #render(cart) {
    const renderTotals = (html) => {
      this.querySelector(".cart-table__footer").outerHTML = html;
    };
    const init = (html) => {
      this.innerHTML = html;
      this.closest("wc-drawer")
        ?.querySelectorAll("wc-renderer")
        ?.forEach((renderer) => renderer.rerender());
    };
    const sections = cart.sections;
    if (sections) {
      document.querySelector("#CartCount").innerText = parseHTML(
        sections["cart-icon"]
      ).querySelector("#shopify-section-cart-icon").innerText;
      const canidateDOM = parseHTML(sections["cart-main"]);
      if (
        cart.item_count === 0 ||
        (cart.item_count > 0 && !this.querySelector(".cart-items"))
      ) {
        init(canidateDOM.querySelector("wc-cart").innerHTML);
      } else {
        const cartTotals = canidateDOM.querySelector(".cart-table__footer");
        console.log(cartTotals, canidateDOM);
        const canidates = Array.from(
          canidateDOM.querySelectorAll(".cart-items > *")
        );
        const cartItems = this.querySelector(".cart-items");
        const nodes = Array.from(cartItems.children);
        console.log(canidates, nodes);
        nodes.forEach((node) => {
          const canidate = canidates.find((d) => node.id === d.id);
          if (!canidate) {
            console.log(node.id, "remove");
            node.remove();
            renderTotals(cartTotals.outerHTML);
          } else if (!node.isEqualNode(canidate)) {
            console.log(node.id, "change");
            node.outerHTML = canidate.outerHTML;
            renderTotals(cartTotals.outerHTML);
          } else {
            console.log(node.id, "no-change");
          }
        });
        canidates
          .filter((canidate) => !nodes.find((node) => node.id === canidate.id))
          .forEach((canidate) => {
            cartItems.append(canidate);
            renderTotals(cartTotals.outerHTML);
          });
      }
    }
  }
}
customElements.define(WCCart.tag, WCCart);

class WCCheckoutButton extends WCDummy {
  #button;
  static #lock;

  static get observedAttributes() {
    return ["lock"];
  }

  constructor() {
    super({ tag: WCCheckoutButton.tag });
    this.#button = this.querySelector("button");
  }

  static get tag() {
    return "wc-checkout-button";
  }

  connectedCallback() {
    if (WCCheckoutButton.lockState) {
      this.#button.disabled = true;
    } else {
      this.#button.disabled = false;
    }
  }

  disconnectedCallback() {}

  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "lock":
        console.log(name, oldValue, newValue);
        break;
    }
  }
  static get lockState() {
    return this.#lock;
  }
  static lock() {
    this.#lock = true;
    document.querySelectorAll(WCCheckoutButton.tag).forEach((d) => {
      d.querySelector("button").disabled = true;
    });
  }
  static release() {
    this.#lock = false;
    document.querySelectorAll(WCCheckoutButton.tag).forEach((d) => {
      d.querySelector("button").disabled = false;
    });
  }
}
customElements.define(WCCheckoutButton.tag, WCCheckoutButton);
window.WCCheckoutButton = WCCheckoutButton;
